function Header_new(){
    return(
        <header>
            <h1>Header_new</h1>
        </header>
    )
}

export default Header_new